module.exports = __webpack_public_path__ + "static/media/growth_analytics.3effe150.svg";